const MessengerColor = () => (
  <svg height="32" width="32" fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3256_15764)">
      <path
        d="M9.27737e-06 15.52C9.27737e-06 6.6 6.98701 0 16 0C25.013 0 32 6.6 32 15.52C32 24.44 25.013 31.04 16 31.04C14.387 31.04 12.827 30.827 11.373 30.427C11.273 30.399 11.159 30.383 11.04 30.383C10.852 30.383 10.673 30.424 10.511 30.497L10.519 30.494L7.33201 31.894C7.17901 31.964 7.00001 32.005 6.81101 32.005C6.11701 32.005 5.55201 31.452 5.53201 30.763V30.761L5.43901 27.908C5.42301 27.547 5.26201 27.227 5.01301 27.002L5.01201 27.001C1.92701 24.21 -0.00299072 20.193 -0.00299072 15.724C-0.00299072 15.653 -0.00199072 15.581 -0.00199072 15.51V15.521L9.27737e-06 15.52ZM11.093 12.6L6.40001 20.067C5.93301 20.774 6.82701 21.587 7.49301 21.067L12.546 17.24C12.893 16.973 13.346 16.973 13.706 17.24L17.439 20.04C18.559 20.88 20.159 20.573 20.906 19.4L25.599 11.933C26.066 11.226 25.172 10.426 24.506 10.933L19.453 14.76C19.12 15.027 18.653 15.027 18.306 14.76L14.573 11.96C14.176 11.657 13.672 11.475 13.126 11.475C12.273 11.475 11.524 11.92 11.098 12.59L11.092 12.6H11.093Z"
        fill="#00B2FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_3256_15764">
        <rect height="32" width="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MessengerColor;
